import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileX } from "lucide-react";
import { api, formatError } from "@/lib/api";
import SchedaStampa from "@/pages/SchedaStampa";
import ContrattoNoleggio from "@/pages/ContrattoNoleggio";
import PrivacyStampa from "@/pages/PrivacyStampa";
import PreventivoStampa from "@/pages/PreventivoStampa";

const PAGES = { scheda: SchedaStampa, contratto: ContrattoNoleggio, privacy: PrivacyStampa, preventivo: PreventivoStampa };

export default function DocumentoPubblico() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/pubblico/${token}`).then((r) => setData(r.data)).catch((e) => setErr(formatError(e)));
  }, [token]);

  if (err) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-100 p-6 text-center" data-testid="documento-errore">
        <FileX className="h-10 w-10 text-slate-400" />
        <p className="font-heading text-lg font-bold text-slate-900">Documento non disponibile</p>
        <p className="text-sm text-slate-500">{err}. Contatta il negozio per ricevere un nuovo link.</p>
      </div>
    );
  }
  if (!data) return <div className="py-20 text-center text-sm text-slate-500">Caricamento...</div>;
  const Page = PAGES[data.tipo];
  return <div data-testid="documento-pubblico"><Page pubblico={{ ...data, token }} /></div>;
}
